import { useMemo } from 'react';
import { useSmartLinkContext } from '@atlaskit/link-provider';
export var useSmartLinkRenderers = function useSmartLinkRenderers() {
  var context = useSmartLinkContext();
  var renderers = context === null || context === void 0 ? void 0 : context.renderers;
  renderers = useMemo(function () {
    return renderers;
  }, [renderers]);
  return renderers;
};